module.exports = __webpack_public_path__ + "components/page-header/static/surf-forecast__logo--clear-50ad82f209bb1c18e5803a9e45e7db84.png";